/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    active: PropTypes.bool,
    color: PropTypes.oneOf([
        'error',
        'warning',
        'success',
        'inactive',
        'action',
        'action-light',
    ]),
};

const defaultProps = {
    ...commonDefaultProps,
    active: false,
    color: 'inactive',
};

const Label = (props) => {
    const classNames = [
        's-label',
        `s-label--${props.color}`,
        props.active ? 's-label--active' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Label.propTypes = propTypes;

Label.defaultProps = defaultProps;

export default Label;
